// frontend/src/links.js

import Home from './main/Home'
import BigQueryExporter from './main/BigQueryExporter'
import LazyLoad from './main/LazyLoad'
import Scheduling from './main/Scheduling'
import AppTaggingTool from './AppTaggingTool'
import VolumeRetrieve from './containers/VolumeRetrieve/VolumeRetrieve'
import KeywordIdeas from './containers/KeywordIdeas/KeywordIdeas'
import DuplicateKeywordsGptForm from './containers/DuplicateKeywordsGptForm/DuplicateKeywordsGptForm'
import DimensionGroups from './tagging_tool/containers/DimensionGroups/DimensionGroupsAdmin'
import CreateReport from './tagging_tool/containers/CreateReport/CreateReport'
import BulkIndexing from './containers/BulkIndexing/BulkIndexing'
import SemRush from './containers/SemRush/SemRush'
import Listing from './tagging_tool/containers/Listing/Listing'
import HtmlCleaner from './containers/HtmlCleaner/HtmlCleaner'
import ContentGen from './containers/ContentGen/ContentGen'
import SiteUrlList from './containers/SeoMonitoring/SiteUrlList'
import { BASE_URL } from './utils'
import KeywordClustering from './containers/KeywordClustering/KeywordClustering'
import PED from './containers/PED/PED'
import MonitoringDashboard from './containers/MonitoringDashboard/MonitoringDashboard'
import KeywordIntentions from './containers/KeywordIntentions/KeywordIntentions'
import LLMVisibilityListing from './containers/LLMVisibility/LLMVisibilityListing'
import LLMVisibilityScheduledListing from './containers/LLMVisibility/LLMVisibilityScheduledListing'
import CategoryTextGenListing from './containers/CategoryTextGen/CategoryTextGenListing'
import ClientCreationList from './containers/ClientCreation/ClientCreationList'
import ClientCreationCreate from './containers/ClientCreation/ClientCreationCreate'

import DomainList from './containers/LinkBuilding/DomainList'
import ProjectList from './containers/LinkBuilding/ProjectList'

var routes = [
  {
    path: 'https://form.asana.com/?k=OKCsOEte-p6k1sUtDAl6Mg&d=280257083226273',
    name: 'Segnalazione',
    icon: 'ni ni-notification-70 text-red',
    layout: '',
    private: true,
  },
  {
    name: 'Ranking',
    icon: 'ni ni-chart-pie-35 text-info',
    private: true,
    childrens: [
      {
        path: '',
        name: 'Rank Inspector',
        icon: 'ni ni-tv-2 text-primary',
        component: Home,
        layout: '/',
        private: true,
      },
      {
        path: 'scheduling',
        name: 'Scheduled Rank Inspector',
        icon: 'ni ni-time-alarm text-blue',
        component: Scheduling,
        layout: '/',
        private: true,
      },
    ],
  },
  {
    path: 'market-screener',
    name: 'Market Screener',
    icon: 'ni ni-chart-bar-32 text-red',
    component: VolumeRetrieve,
    layout: '/',
    private: true,
  },
  {
    name: 'Utils',
    icon: 'ni ni-settings-gear-65 text-gray',
    private: true,
    childrens: [
      {
        path: 'keyword-ideas',
        name: 'Keyword Ideas',
        icon: 'ni ni-bulb-61 text-orange',
        component: KeywordIdeas,
        layout: '/',
        private: true,
      },
      {
        path: 'duplicate-keywords-gpt',
        name: 'Duplicate Keywords GPT',
        icon: 'ni ni-key-25 text-info',
        component: DuplicateKeywordsGptForm,
        layout: '/',
        private: true,
      },
      {
        path: 'keyword-clustering',
        name: 'Keyword Clustering',
        icon: 'ni ni-atom text-info',
        component: KeywordClustering,
        layout: '/',
        private: true,
      },
      {
        path: 'ped-generator',
        name: 'PED Generator 🔮',
        icon: 'ni ni-align-left-2 text-info',
        component: PED,
        layout: '/',
        private: true,
      },
      {
        path: 'content-gen',
        name: 'Content Gen 🔮',
        icon: 'ni ni-ruler-pencil text-green',
        component: ContentGen,
        layout: '/',
        private: true,
      },
      {
        path: 'category-text-gen',
        name: 'Category Gen 🔨',
        icon: 'fa-solid fa-file-lines text-blue',
        component: CategoryTextGenListing,
        layout: '/',
        private: true,
      },
      {
        path: 'lazy-load',
        name: 'Lazy Load',
        icon: 'ni ni-button-pause text-purple',
        component: LazyLoad,
        layout: '/',
        private: true,
      },
      {
        path: 'bigquery-exporter',
        name: 'Bigquery Exporter',
        icon: 'ni ni-folder-17 text-green',
        component: BigQueryExporter,
        layout: '/',
        private: true,
      },
      {
        path: 'bulk-indexing',
        name: 'Bulk Indexing',
        icon: 'fa fa-rss text-info',
        component: BulkIndexing,
        layout: '/',
        private: true,
      },
      {
        path: 'semrush',
        name: 'SemRush',
        icon: 'fa fa-fire text-orange',
        component: SemRush,
        layout: '/',
        private: true,
      },
      {
        path: 'html-cleaner',
        name: 'HtmlCleaner 🧼',
        icon: 'fa fa-paint-brush text-green',
        component: HtmlCleaner,
        layout: '/',
        private: true,
      },
    ],
  },
  {
    name: 'LLM Visibility 🔨',
    icon: 'far fa-comments text-blue',
    private: true,
    childrens: [
      {
        path: 'llm-visibility',
        name: 'One-Shot',
        icon: 'far fa-comment-dots text-blue',
        component: LLMVisibilityListing,
        layout: '/',
        private: true,
      },
      {
        path: 'llm-visibility-scheduled',
        name: 'Scheduled',
        icon: 'far fa-calendar-alt text-blue',
        component: LLMVisibilityScheduledListing,
        layout: '/',
        private: true,
      },
    ],
  },
  {
    path: 'seo-sentinel/site-urls',
    name: 'Seo Sentinel',
    icon: 'ni ni-compass-04 text-green',
    component: SiteUrlList,
    layout: '/',
    private: true,
  },
  {
    name: 'Client Creation',
    icon: 'ni ni-single-02 text-info',
    private: true,
    childrens: [
      {
        path: 'client-creation/clienti',
        name: 'Lista Clienti',
        icon: 'ni ni-bullet-list-67 text-blue',
        component: ClientCreationList,
        layout: '/',
        private: true,
      },
      {
        path: 'client-creation/create',
        name: 'Crea Cliente',
        icon: 'ni ni-fat-add text-green',
        component: ClientCreationCreate,
        layout: '/',
        private: true,
      },
    ],
  },
  {
    name: 'Link Building',
    icon: 'ni ni-world-2 text-primary',
    private: true,
    childrens: [
      {
        path: 'link-building/domains',
        name: 'Domain Database',
        icon: 'ni ni-collection text-blue',
        component: DomainList,
        layout: '/',
        private: true,
      },
      {
        path: 'link-building/projects',
        name: 'Projects',
        icon: 'ni ni-briefcase-24 text-orange',
        component: ProjectList,
        layout: '/',
        private: true,
      },
    ],
  },
  {
    path: 'keyword-intentions',
    name: 'Keyword Intentions',
    icon: 'ni ni-bullet-list-67 text-green',
    component: KeywordIntentions,
    layout: '/',
    private: true,
  },
  {
    path: 'monitoring-dashboard',
    name: 'Monitoring Dashboard',
    icon: 'ni ni-sound-wave text-info',
    component: MonitoringDashboard,
    layout: '/',
    private: true,
  },
  {
    path: 'reporting',
    name: 'Tagging Tool',
    icon: 'ni ni-tag text-pink',
    component: AppTaggingTool,
    layout: '/',
    private: true,
    childrens: [
      {
        path: 'reporting',
        name: 'Lista Report',
        component: Listing,
        layout: '/',
      },
      {
        path: 'reporting-create',
        name: 'Creazione Report',
        component: CreateReport,
        layout: '/',
      },
      {
        path: 'reporting-dimension-groups',
        name: 'Dimensioni e Regole Salvate',
        component: DimensionGroups,
        layout: '/',
      },
      //{
      //  path: "reporting/ai-regex-beta",
      //  name: "AI Regex Beta",
      //  layout: "/"
      //},
      {
        path: 'docs/documentazione_seo/tagging-tool-wiki/',
        name: 'Guida',
        layout: '',
      },
    ],
  },
  {
    path: BASE_URL + '/docs/',
    name: 'Docs',
    icon: 'ni ni-support-16 text-blue',
    layout: '',
    private: true,
  },
]

export default routes
